<ubl-subscribe [data]="subscribeData" (showPrivacy)="showAgreements()"></ubl-subscribe>

<app-modal *ngIf="showModal" [isShow]="showModal" (close)="showModal = false">
    <div class="agreement">
        <div *ngIf="subscribeData?.agreementText?.title" class="agreement__title" [innerHTML]="subscribeData.agreementText.title"></div>
        <div *ngIf="subscribeData?.agreementText?.description" class="agreement__description" [innerHTML]="subscribeData.agreementText.description"></div>
    </div>
</app-modal>


